/**
 * Telegram channel (`site_settings.telegram_username`, migration 0023): the bare
 * handle the public site links to as https://t.me/<name> on the homepage hero and
 * /contact. Mirrors `common.NormalizeTelegramUsername` in the backend, which
 * enforces the same rule on PUT /admin/settings (422 on `telegram_username`).
 */

const USERNAME = /^[A-Za-z][A-Za-z0-9_]{3,30}[A-Za-z0-9]$/;
const PREFIXES = ['https://t.me/', 'http://t.me/', 't.me/', 'https://telegram.me/', 'telegram.me/', '@'];

/** Strips what an editor is likely to paste ("@name", "https://t.me/name/"). */
export function normalizeTelegramUsername(raw: string): string {
  let v = raw.trim();
  const lower = v.toLowerCase();
  const prefix = PREFIXES.find((p) => lower.startsWith(p));
  if (prefix) v = v.slice(prefix.length);
  return v.replace(/\/$/, '');
}

/** `invalid` when the normalized value is not a Telegram username; empty is valid (channel off). */
export function validateTelegramUsername(raw: string): 'invalid' | undefined {
  const v = normalizeTelegramUsername(raw);
  return v === '' || USERNAME.test(v) ? undefined : 'invalid';
}
